import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import menus from "vue3-menus";
import { createPinia } from "pinia"; // pinia
import i18n from "@/lang";
import directives from "@/directive";
import "emoji-mart-vue-fast/css/emoji-mart.css";
import "element-plus/dist/index.css";
import "element-plus/theme-chalk/dark/css-vars.css";
import "./styles/index.scss";
import * as ElementPlusIconsVue from "@element-plus/icons-vue"; // element 字体图标
import Nodata from "@/components/NoData/index.vue";
import Pagination from "@/components/Pagination/index.vue";
import { menusEvent } from "vue3-menus";
const app = createApp(App);
app.component(Nodata);
app.component(Pagination);
console.log(`🚀 当前版本: v ${process.env.APP_VERSION}`);
import Particles from "vue3-particles"; // 粒子插件
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
app.config.globalProperties.$menusEvent = menusEvent; // 只绑定方法
app
  .use(createPinia())
  .use(Particles)
  .use(menus)
  .use(router)
  .use(i18n)
  .use(directives)
  .mount("#app");
